/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandCardRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandCardResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandCard = (request: SetBrandCardRequest, options?: CashRequestOptions) => post<SetBrandCardRequest, SetBrandCardResponse>("/2.0/cash/set-brand-card", request, {...options, rejectOnError: true })